var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ImageMedia',{class:_vm.isotype ? 'isotype' : 'rever-logo',attrs:{"data-private":"","src":_vm.logo,"defaultImage":_vm.defaultImage}})
}
var staticRenderFns = []

export { render, staticRenderFns }